const config = {
    'billIndex': {
        'bigData-btn-search': '财务结算,账单核对,,账单核对-查询'
    },
    'depositIndex': {
        'bigData-btn-search': '财务结算,押金管理,,押金管理-查询'
    },
    'costIndex': {
        'bigData-btn-search': '财务结算,费用核对,,费用核对-查询'
    },
    'fineIndex': {
        'bigData-btn-search': '财务结算,罚扣款核对,,罚扣款核对-查询'
    },
    'DepositDetails': {
        'bigData-btn-look': '财务结算,押金管理,详情界面,查看收据'
    },
    'SettleIndex': {
        'bigData-btn-search': '财务结算,结算申请,,结算申请-查询'
    }

};
export default config;